import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propNumber } from '../../../../helpers/custom-prop-types';
import CalendarIcon from '../../../Icon/Svg/CalendarIcon';
const SolutionPeriod = (props) => {
    const { period } = props;
    if (!period) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'ui-solution-period' }, { children: [_jsx(CalendarIcon, {}), _jsx("span", Object.assign({ className: 'period-text' }, { children: `約${period}週間` }))] })));
};
SolutionPeriod.propTypes = {
    period: propNumber().isRequired,
};
export default SolutionPeriod;
